import { BehaviorSubject, map, Observable, of, switchMap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { inject, Injectable } from '@angular/core';

import { suggestionButton } from '../functions/utils.ai';

@Injectable({ providedIn: 'root' })
export class AIChatboxSuggestionsService {
    private readonly i18n = inject(TranslateService)

    private suggestions = new BehaviorSubject<string[]>([])
    private pageContextSuggestionsTexts$: Observable<string[]> = this.suggestions.pipe(
        switchMap(keys => keys.length
            ? this.i18n.stream(keys)
            : of([])
        ),
        map(texts => Object.values(texts))
    )

    pageContextSuggestionsButtons$ = this.pageContextSuggestionsTexts$.pipe(
        map(suggestions => suggestions.map(s => suggestionButton(s)))
    )

    resetSuggestionsKeys() {
        this.suggestions.next([])
    }

    setSuggestionsKeys(items: string[]) {
        this.suggestions.next(items)
    }
}